var map = {
	"./organization.js": "pfCd",
	"./people.js": "flvh",
	"./personnel.js": "RWhq",
	"./role.js": "SeMm",
	"./salary.js": "F+7C",
	"./train.js": "71fK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Zm3W";


//////////////////
// WEBPACK FOOTER
// ./src/router/human nonrecursive ^(?!\.\/index).*\.js$
// module id = Zm3W
// module chunks = 225